module.exports = __webpack_public_path__ + "static/cp-lines-8ac11218a4f29c322a812aeab963738c.png";